import React from 'react'
import PropTypes from 'prop-types'
import styles from './master-form.module.css'
import { CustomerType } from './master-form'

export default class StepCustomerType extends React.Component {
  render() {
    return (
      <>
        <p className={styles.question}>Are you looking for <b>business</b> or home energy?</p>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.customerType === CustomerType.Business}
            className={styles.formCheckInput}
            id={CustomerType.Business}
            name="customerType"
            value={CustomerType.Business}
            onChange={this.props.handleChange}
          />
          <label htmlFor={CustomerType.Business}>Business</label>
        </div>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.customerType === CustomerType.Home}
            className={styles.formCheckInput}
            id={CustomerType.Home}
            name="customerType"
            value={CustomerType.Home}
            onChange={this.props.handleChange}
          />
          <label htmlFor={CustomerType.Home}>Home</label>
        </div>
      </>
    )
  }
}

StepCustomerType.propTypes = {
  customerType: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
}
